import { render, staticRenderFns } from "./coursePage.vue?vue&type=template&id=416c65d4&"
import script from "./coursePage.vue?vue&type=script&lang=js&"
export * from "./coursePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports